import Block from '../block'

import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'

export default class FooterParallax extends Block {
	static title = 'footer-parallax'

	constructor($el) {
		super($el)

		// register gsap plugins
		gsap.registerPlugin(ScrollTrigger)

		this.initFooterParallax()
	}

	initFooterParallax() {
		if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return

		document.querySelectorAll('[data-footer-parallax]').forEach((el) => {
			const tl = gsap.timeline({
				scrollTrigger: {
					trigger: el,
					start: 'clamp(top bottom)',
					end: 'clamp(top top)',
					scrub: true,
				},
			})

			const inner = el.querySelector('[data-footer-parallax-inner]')
			const dark = el.querySelector('[data-footer-parallax-dark]')

			if (inner) {
				tl.from(inner, {
					yPercent: -25,
					ease: 'linear',
				})
			}

			if (dark) {
				tl.from(
					dark,
					{
						opacity: 0.5,
						ease: 'linear',
					},
					'<',
				)
			}
		})
	}
}
